import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import ModalMask from '@stubhub/react-modal-mask';

const BottomModalContainer = ({onClose, children, OnModalMaskClick}) => {
  const quantityHeader = <FormattedMessage id="BottomModalContainer.Quantity" defaultMessage="Quantity" />;

  return (
    <div className="BottomModalContainer">
      <ModalMask onClick={OnModalMaskClick}>
        <div className="BottomModalContainer__wrapper">
          <div className="BottomModalContainer__wrapper-header">
            {quantityHeader}
            <Icon name="Close" className="BottomModalContainer__wrapper-closeIcon" onClick={onClose} />
          </div>
          <ul className="BottomModalContainer__squareQtyContainer">{children}</ul>
        </div>
      </ModalMask>
    </div>
  );
};

BottomModalContainer.propTypes = {
  children: PropTypes.element,
  OnModalMaskClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default BottomModalContainer;
